import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Título do banner da página (`app-title`).
 *
 * <p>Por padrão o banner mostra o `title` da rota, que é estático. Telas cujo título
 * depende do dado carregado — "Editar folha ABRIL 2026", "Visualizar lote JANEIRO 2026" —
 * chamam {@link definir} depois de carregar a competência. Esse título é descartado a cada
 * navegação: `app-title` chama {@link limpar} no `NavigationStart`.</p>
 *
 * <p>{@link setOverride} é o override controlado pela própria tela (que o desfaz no
 * `ngOnDestroy`) e não é limpo automaticamente.</p>
 */
@Injectable({ providedIn: 'root' })
export class PageTitleService {
  /** Título que substitui o da rota. `null` mantém o `title` da rota. */
  readonly titulo = signal<string | null>(null);

  private readonly overrideSubject = new BehaviorSubject<string | null>(null);
  readonly override$ = this.overrideSubject.asObservable();

  definir(titulo: string): void {
    this.titulo.set(titulo);
  }

  limpar(): void {
    this.titulo.set(null);
  }

  setOverride(title: string | null): void {
    this.overrideSubject.next(title);
  }
}
